var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.noticias.length > 0)?_c('marquee-text',{attrs:{"duration":120,"repeat":2}},[_c('p',[_vm._v(" "+_vm._s(_vm.noticias)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }